/** @sfdc-extension-file SNK */
'use client';

import { useEffect, useState, type ComponentPropsWithoutRef, type ReactElement } from 'react';
import type { WithCategoryNavigationMenu } from '@/components/navigation-menu';
import { useBurgerMenuContent } from '@/extensions/snk/lib/use-burger-menu-content';
import { BurgerMenuPanel } from './ui/organisms/panel';

type BurgerMenuProps = ComponentPropsWithoutRef<typeof WithCategoryNavigationMenu> & {
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export const MenuDrawerContent = ({
    resolve,
    defer: _defer,
    open,
    onOpenChange,
    ...menuProps
}: BurgerMenuProps): ReactElement | null => {
    const [hasOpened, setHasOpened] = useState(false);
    const { subCategoriesPromise, burgerMenuRegions, menuOverrides, categorySubmenuSlots, isMenuContentLoading } =
        useBurgerMenuContent(open);

    useEffect(() => {
        if (open) {
            setHasOpened(true);
        }
    }, [open]);

    if (!hasOpened) {
        return null;
    }

    return (
        <BurgerMenuPanel
            rootCategoryPromise={resolve}
            subCategoriesPromise={subCategoriesPromise}
            menuOverrides={menuOverrides}
            categorySubmenuSlots={categorySubmenuSlots}
            burgerMenuRegions={burgerMenuRegions}
            isMenuContentLoading={isMenuContentLoading}
            open={open}
            onOpenChange={onOpenChange}
            {...menuProps}
        />
    );
};
